module.exports = __webpack_public_path__ + "img/pdf-file-icon.1716205a.jpeg";